import React, {useState} from 'react'
import {Box} from '@mui/material'
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined'
import ChoiceChip from 'src/components-new/primitives/ChoiceChip'
import TextFieldNew from 'src/components-new/inputs/TextFieldNew'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'
import {getOtherBodyPart, setOtherBodyPart, toggleBodyPart} from 'src/constants/secondaryAssumptions'
import SectionTitleNew from './SectionTitleNew'

// Free text by contract, but the common answers are offered as one-tap chips — several can be
// selected at once. The text field only appears behind "Altro", so the usual case stays a tap or
// two with nothing else on screen.

interface BodyPartPickerNewProps {
  value: string[]
  onChange: (value: string[]) => void
  suggestions: string[]
  disabled?: boolean
}

export default function BodyPartPickerNew({value, onChange, suggestions, disabled}: BodyPartPickerNewProps): JSX.Element {
  const otherValue = getOtherBodyPart(value, suggestions)
  // a previous answer outside the shortcuts (reopened link) must show up in the open text field
  const [isOtherOpen, setIsOtherOpen] = useState<boolean>(Boolean(otherValue))

  const onOtherClick = (): void => {
    if (isOtherOpen) {
      setIsOtherOpen(false)
      onChange(setOtherBodyPart(value, suggestions, ''))
      return
    }
    setIsOtherOpen(true)
  }

  return (
    <Box>
      <SectionTitleNew icon={AccessibilityNewOutlinedIcon}>
        Parte del corpo{' '}
        <Box component="span" sx={{fontWeight: 400, textTransform: 'none', letterSpacing: 0, color: NEUTRAL_SCALE[500]}}>
          (facoltativo, anche più di una)
        </Box>
      </SectionTitleNew>
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1}}>
        {suggestions.map((suggestion) => (
          <ChoiceChip
            key={suggestion}
            label={suggestion}
            selected={value.includes(suggestion)}
            disabled={disabled}
            onClick={() => onChange(toggleBodyPart(value, suggestion))}
          />
        ))}
        <ChoiceChip label="Altro" selected={isOtherOpen} disabled={disabled} onClick={onOtherClick} />
      </Box>
      {isOtherOpen && (
        <TextFieldNew
          fullWidth
          autoFocus={!otherValue}
          disabled={disabled}
          placeholder="Specifica la parte del corpo"
          value={otherValue}
          onChange={(other) => onChange(setOtherBodyPart(value, suggestions, other))}
          sx={{mt: 1.5}}
        />
      )}
    </Box>
  )
}
